import {SupportTicketResolutionEnum} from '../../../../model/support/support-ticket-resolution.enum';
import {SupportTicketStatusEnum} from '../../../../model/support/support-ticket-status.enum';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SearchIcon from '@mui/icons-material/Search';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; // fallback
import EventIcon from '@mui/icons-material/Event';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReplayIcon from '@mui/icons-material/Replay';

export namespace SupportTicketUtils {
  export const ticketPriorityOptions = [
    {value: 1, label: '1 - Bardzo niski priorytet'},
    {value: 2, label: '2 - Niski priorytet'},
    {value: 3, label: '3 - Umiarkowany'},
    {value: 4, label: '4 - Wysoki'},
    {value: 5, label: '5 - Bardzo wysoki'},
    {value: 6, label: '6 - Krytyczny'},
  ]

  export const ticketBudgetTypeOptions = [
    {value: 'INTERNAL_SUPPORT_PLAN_BUDGET', label: 'Budżet wsparcia technicznego'},
    {value: 'EXTERNAL_BUDGET', label: 'Dodatkowy budżet'}
  ]

  export const getStatusIcon = (status: SupportTicketStatusEnum): React.ElementType => {
    if (status === SupportTicketStatusEnum.PENDING) return HourglassEmptyIcon
    if (status === SupportTicketStatusEnum.PROCESSING) return SearchIcon
    if (status === SupportTicketStatusEnum.IN_PROGRESS) return BuildIcon
    if (status === SupportTicketStatusEnum.RESOLVED) return CheckCircleIcon
    if (status === SupportTicketStatusEnum.REOPENED) return ReplayIcon
    if (status === SupportTicketStatusEnum.CLOSED) return CheckCircleIcon

    return HelpOutlineIcon
  }

  export const getStatusIconColor = (status: SupportTicketStatusEnum): string => {
    if (status === SupportTicketStatusEnum.PENDING) return '#FF7074'
    if (status === SupportTicketStatusEnum.IN_PROGRESS) return 'gray'
    if (status === SupportTicketStatusEnum.RESOLVED) return 'green'
    if (status === SupportTicketStatusEnum.REOPENED) return '#FF7074'
    if (status === SupportTicketStatusEnum.CLOSED) return 'green'

    return '#1E3A8A'
  }

  export const getResolutionIcon = (resolution: SupportTicketResolutionEnum): React.ElementType => {
    if(resolution === SupportTicketResolutionEnum.FIX_SCHEDULED) return BuildIcon
    if(resolution === SupportTicketResolutionEnum.FEATURE_NOT_EXISTS) return EventIcon

    return ErrorOutlineIcon
  }

  export const getResolutionIconColor = (resolution: SupportTicketResolutionEnum): string => {
    if(resolution === SupportTicketResolutionEnum.FIX_SCHEDULED) return 'gray'
    if(resolution === SupportTicketResolutionEnum.FEATURE_NOT_EXISTS) return '#1E3A8A'

    return '#FF7074'
  }
}